import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const getDirectionOffset = () => {
    switch (direction) {
      case 'up':
        return {
          y: 40
        };
      case 'down':
        return {
          y: -40
        };
      case 'left':
        return {
          x: 40
        };
      case 'right':
        return {
          x: -40
        };
      case 'none':
        return {};
      default:
        return {
          y: 40
        };
    }
  };
  return <motion.div ref={ref} initial={{
    opacity: 0,
    ...getDirectionOffset()
  }} animate={isInView ? {
    opacity: 1,
    x: 0,
    y: 0
  } : {
    opacity: 0,
    ...getDirectionOffset()
  }} transition={{
    duration: 0.8,
    delay: delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-168">
      {children}
    </motion.div>;
}